import { Terminal } from 'lucide-react';
import { AppLayout } from '@/components/layout/AppLayout';

interface StaticPageLayoutProps {
 title: string;
 lastUpdated?: string;
 children: React.ReactNode;
}

export function StaticPageLayout({
 title,
 lastUpdated,
 children,
}: StaticPageLayoutProps) {
 return (
  <AppLayout>
   <div className='max-w-3xl mx-auto'>
    <div className='border-b border-border pb-8 mb-8'>
     <div className='flex items-center gap-2 mb-4 text-primary font-mono text-xs uppercase'>
      <Terminal className='w-4 h-4' />
      <span>SYSTEM_DOC_VIEWER</span>
     </div>
     <h1 className='text-4xl font-bold font-mono uppercase tracking-tight mb-2'>
      {title}
     </h1>
     {lastUpdated && (
      <p className='font-mono text-xs text-muted-foreground uppercase'>
       LAST_UPDATED: {lastUpdated}
      </p>
     )}
    </div>

    <div className='prose prose-invert prose-green max-w-none font-sans leading-relaxed'>
     {children}
    </div>
   </div>
  </AppLayout>
 );
}
